var _defs, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-b098ed0f-324d-402f-a267-4720800fa718",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-b18e4232-0814-4884-83f4-05870f72078d {\n        fill: #f2f2f2;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-b18e4232-0814-4884-83f4-05870f72078d",
    cx: 16,
    cy: 16,
    r: 1.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-b18e4232-0814-4884-83f4-05870f72078d",
    cx: 16,
    cy: 21.25,
    r: 1.75
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-b18e4232-0814-4884-83f4-05870f72078d",
    cx: 16,
    cy: 10.75,
    r: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUp);
export default __webpack_public_path__ + "static/media/MenuUp.7a548020f34285989f461b77b0ec8c32.svg";
export { ForwardRef as ReactComponent };